import React from 'react';
import { Container, Grid, Card, CardContent, Typography, Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import AwardIcon from '@mui/icons-material/EmojiEvents';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import WalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ComplianceIcon from '@mui/icons-material/AssignmentTurnedIn';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Initialize AOS
AOS.init();

function Services() {
  const services = [
    {
      title: 'Personalized Attention',
      description: 'We focus on creating tailor-made solutions for each client, ensuring that your specific needs are met with precision.',
      icon: <PersonIcon style={{ color: '#f3268c', fontSize: '4rem' }} />,
    },
    {
      title: 'Certified Experts',
      description: 'Our certified accountants and tax professionals provide services that are both accurate and compliant, making sure your business thrives.',
      icon: <AwardIcon style={{ color: '#fd7e14', fontSize: '4rem' }} />,
    },
    {
      title: 'Proactive Approach',
      description: 'We don’t just manage your finances, we provide strategic advice to help your business grow and reach new heights.',
      icon: <LightbulbIcon style={{ color: '#20c997', fontSize: '4rem' }} />,
    },
    {
      title: 'Comprehensive Solutions',
      description: 'We provide a full suite of services, including bookkeeping, payroll management, and tax planning, ensuring all aspects of your finances are in safe hands.',
      icon: <WalletIcon style={{ color: '#df1529', fontSize: '4rem' }} />,
    },
    {
      title: 'Commitment to Compliance',
      description: 'We keep up with ever-changing tax laws, ensuring your business remains fully compliant and protected from legal risks.',
      icon: <ComplianceIcon style={{ color: '#6610f2', fontSize: '4rem' }} />,
    },
  ];

  return (
    <Container maxWidth="lg" style={{ marginTop: '2rem' }}>
      {/* Section Title */}
      <Box textAlign="center" mb={5}>
        <Typography variant="h4" gutterBottom>
          Our Services
        </Typography>
        <Typography variant="subtitle1">
          Discover Why Fincal Business Solutions Stands Out
        </Typography>
      </Box>

      {/* Services Grid */}
      <Grid container spacing={4}>
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              data-aos="fade-up"
              data-aos-delay={`${100 * (index + 1)}`}
              style={{
                position: 'relative',
                padding: '1.5rem',
                height: '100%',
                transition: 'transform 0.3s ease',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            >
              <CardContent>
                {/* Service Icon */}
                <Box textAlign="center" mb={3}>
                  {service.icon}
                </Box>

                {/* Service Title */}
                <Typography variant="h5" align="center" gutterBottom>
                  {service.title}
                </Typography>

                {/* Service Description */}
                <Typography variant="body2" color="textSecondary" align="center">
                  {service.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default Services;
